import React,{Fragment} from 'react';

import{Header,Banner,Slider, Services, GetInTouch,Footer} from "./components/";
export default(props)=>{
    const data=props.data;

    return(
        <Fragment>
         <Slider data={data}/>
        <Services data={data}/>
        <GetInTouch data={data}/>
        </Fragment>
    )
}